module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-01.7eb8b4cf.png";